import PropTypes from 'prop-types';
import Button from 'components/UI/Button';

const ValidationFailedScreen = ({
  literals,
  onRetakePhotos,
  onChangePledge,
  onBack,
}) => (
  <div className='full-screen-container digital-loan-result-screen'>
    <div className='screen-content'>
      <h1 className='digital-loan-phase2__title'>{literals.title}</h1>
      <p className='digital-loan-result-screen__subtitle'>{literals.subtitle}</p>
      <p className='digital-loan-phase2__body'>{literals.body1}</p>
      <p className='digital-loan-phase2__body mb-4'>{literals.body2}</p>
    </div>
    <div className='screen-actions'>
      <Button text={literals.retakePhotos} onClick={onRetakePhotos} />
      <p className='digital-loan-result-screen__alt'>{literals.changePledgeHint}</p>
      <Button text={literals.changePledge} onClick={onChangePledge} />
      <Button text={literals.back} type='secondary' onClick={onBack} />
    </div>
  </div>
);

ValidationFailedScreen.propTypes = {
  literals: PropTypes.object.isRequired,
  onRetakePhotos: PropTypes.func.isRequired,
  onChangePledge: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default ValidationFailedScreen;
